export const CORE_MESSAGES = {
  CONFIG_NOT_SET: 'Runtime config has not been set. Was bootstrap completed?',
  ENV_CONFIG_MISSING: 'No configuration found for environment: {environment}',
  FACADE_CALL_FAILED: 'Facade call failed.',
  BOOTSTRAP_NOT_COMPLETE: 'Bootstrap completed but facade instance was not set.',
  BOOTSTRAP_FAILED: 'Bootstrap failed: {error}',
  FACADE_QUEUING: 'Facade called before bootstrap started, queuing call...',
} as const;
